import React from "react";
import { motion } from "framer-motion"; // ✅ Import framer-motion

import heroImg from "../assets/About-Us-Cover-photo.png"; 
import missionImg from "../assets/mission.jpeg";
import visionImg from "../assets/vision.jpeg";
import team1 from "../assets/team1.jpg";
import team2 from "../assets/team2.jpg";
import team3 from "../assets/team3.jpg";
import team4 from "../assets/team4.jpeg";
import team5 from "../assets/team5.jpg";
import team6 from "../assets/team6.jpg";

const AboutUs = () => {
  return (
    <div className="bg-black text-white">
      {/* ================= HERO ================= */}
<section
  className="relative min-h-[55vh] flex items-center justify-center overflow-hidden bg-cover bg-center"
  style={{ backgroundImage: `url(${heroImg})` }}
>
  {/* Background Overlay */}
  <div className="absolute inset-0 bg-black/60"></div>

  {/* Decorative circles */}
  <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>
  <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>

  <div className="relative z-10 text-center max-w-4xl mx-auto px-6">

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
    >
      Who We Are
    </motion.p>

    <motion.h1
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="text-5xl md:text-7xl font-bold mb-6"
    >
      ABOUT <span className="text-lime-400">ACoT</span>
    </motion.h1>

    <motion.p
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.2 }}
      className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
    >
      Together we strive to protect wildlife, conserve nature, and build a sustainable future 🌍
    </motion.p>

  </div>
</section>
      {/* About ACoT Intro Section */}
<section className="py-20 bg-gradient-to-b from-black to-gray-900">
  <div className="w-11/12 md:w-3/5 mx-auto text-center">

    <motion.h2
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-3xl md:text-4xl font-bold text-lime-400 mb-8"
    >
      About Ajaya Conservation Trust (ACoT)
    </motion.h2>

    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      viewport={{ once: true }}
      className="bg-gray-900/80 backdrop-blur-md border border-lime-400/20 rounded-2xl p-8 md:p-10 shadow-xl hover:shadow-lime-400/10 transition"
    >
      <p className="text-gray-300 leading-relaxed text-lg">
        <span className="text-lime-400 font-semibold">
          Ajaya Conservation Trust (ACoT)
        </span>, founded in May 2025, is an Odisha-based public charitable trust dedicated to advancing 
        science-based and community-driven approaches to biodiversity conservation and sustainable development across India.  

        <br /><br />

        Our work spans terrestrial, freshwater, coastal, and marine ecosystems, integrating ecological research with participatory governance, climate adaptation, and disaster resilience.  

        <br /><br />

        By combining traditional knowledge with modern conservation science, ACoT strives to restore degraded landscapes, strengthen community livelihoods, and foster harmony between people and nature for a resilient and sustainable future.
      </p>
    </motion.div>

  </div>
</section>

      {/* Mission & Vision */}
      <section className="py-16 w-11/12 md:w-4/5 mx-auto grid md:grid-cols-2 gap-10">
        <div className="bg-gray-900 rounded-xl p-8 shadow-lg hover:scale-105 transition">
          <img src={missionImg} alt="Mission" className="rounded-lg mb-4" />
          <h2 className="text-2xl font-bold text-lime-400 mb-2">Our Mission</h2>
          <p className="text-gray-300">
            To advance biodiversity conservation and sustainable development across India through science-based research, participatory environmental governance, and community-led livelihood initiatives.
          </p>
        </div>

        <div className="bg-gray-900 rounded-xl p-8 shadow-lg hover:scale-105 transition">
          <img src={visionImg} alt="Vision" className="rounded-lg mb-4" />
          <h2 className="text-2xl font-bold text-lime-400 mb-2">Our Vision</h2>
          <p className="text-gray-300">
            A resilient India where thriving ecosystems and empowered communities coexist in harmony, ensuring biodiversity conservation, ecological integrity, climate resilience, and sustainable prosperity for generations to come.
          </p>
        </div>
      </section>

      {/* Impact Numbers */}
      <section className="bg-gray-800 py-16">
  <div className="w-11/12 md:w-4/5 mx-auto">

    {/* Keep heading consistent with your other sections */}
    <h2 className="text-3xl font-bold text-lime-400 text-center mb-10">
          Our Impact
        </h2>

    {/* Impact cards */}
    <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20">

      <div className="bg-gray-900 px-12 py-10 rounded-xl text-center shadow-lg 
                      border border-gray-700 hover:border-lime-400 
                      hover:scale-105 transition duration-300 min-w-[220px]">

        <h3 className="text-4xl font-bold text-lime-400">3+</h3>
        <p className="text-gray-300 mt-2">Projects</p>
      </div>

      <div className="bg-gray-900 px-12 py-10 rounded-xl text-center shadow-lg 
                      border border-gray-700 hover:border-lime-400 
                      hover:scale-105 transition duration-300 min-w-[220px]">

        <h3 className="text-4xl font-bold text-lime-400">35+</h3>
        <p className="text-gray-300 mt-2">Volunteers</p>
      </div>

      <div className="bg-gray-900 px-12 py-10 rounded-xl text-center shadow-lg 
                      border border-gray-700 hover:border-lime-400 
                      hover:scale-105 transition duration-300 min-w-[220px]">

        <h3 className="text-4xl font-bold text-lime-400">7+</h3>
        <p className="text-gray-300 mt-2">Districts</p>
      </div>

    </div>

  </div>
</section>
    </div>
  );
};

export default AboutUs;
